import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UserPreferencesDto } from './types/user-preferences-dto.type';

/**
 * Fetches the current user's preferences blob.
 *
 * The user is resolved server-side from the secure cookie / Redis ticket store —
 * no userId is passed.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @returns OperationResultWithData wrapping the `UserPreferences` blob. The
 *          server returns `{}` when no preferences have been persisted yet.
 */
export const getPreferences = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<UserPreferencesDto>>(Uri.preferences.base).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
